var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMobileRegular = function SvgMobileRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.063 4.75c.957 0 1.75.793 1.75 1.75V17c0 .984-.793 1.75-1.75 1.75H8.936c-.984 0-1.75-.766-1.75-1.75V6.5c0-.957.766-1.75 1.75-1.75h6.126ZM15.5 17V6.5a.47.47 0 0 0-.438-.438H8.939A.45.45 0 0 0 8.5 6.5V17c0 .246.191.438.438.438h6.124A.45.45 0 0 0 15.5 17Zm-2.625-1.313a.47.47 0 0 1 .438.438.45.45 0 0 1-.438.438h-1.75a.432.432 0 0 1-.438-.438.45.45 0 0 1 .438-.438h1.75Z"
  })));
};

export default SvgMobileRegular;